import { getBrowserString } from "@/components/shared/util";
import { navigationNamespace } from "@/store/modules/navigation";
import { patientNamespace } from "@/store/modules/patient";
import { Patient } from "@/store/modules/patient/types";
import { userNamespace } from "@/store/modules/user";
import _ from "lodash";
import { Component, Prop, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
@Component({})
export default class SendFeedback extends Vue {
  text = "";
  dialogOpen = false;
  sending = false;
  error = "";
  name: string = "";
  email: string = "";

  @Getter("current", patientNamespace)
  current!: Patient;

  @Getter("fullName", userNamespace)
  fullName!: string;

  @Getter("email", userNamespace)
  emailAddress!: string;

  @Action("accessRequest", userNamespace)
  accessRequest!: Function;

  @Getter("area", patientNamespace)
  area!: string;

  @Getter("demo", userNamespace)
  demo!: boolean;

  @Getter("helpStep", navigationNamespace)
  step!: number;

  @Getter("isActiveTest", patientNamespace)
  isActiveTest!: boolean;

  @Action("getActiveCases", userNamespace)
  getActiveCases!: Function;

  @Prop(Boolean)
  showText!: boolean;

  @Prop(String)
  textToShow!: string;

  get isPatientView() {
    return this.$route.params["room"] != null;
  }

  get testIcon() {
    return this.isActiveTest ? "stop" : "format_list_numbered";
  }

  get testText() {
    return (this.isActiveTest ? "Stop" : "Start") + " Testing";
  }

  showFeedback() {
    if (!this.name) {
      this.name = this.fullName;
    }
    if (!this.email) {
      this.email = this.emailAddress;
    }

    this.dialogOpen = true;
  }
  sendFeedback() {
    if (this.text === "") {
      return;
    }
    if (this.demo) {
      this.handleResponse(true);
      return;
    }
    this.sending = true;
    let message = `${this.name}: ${this.text}`;
    if (this.email) {
      message += ` Email: ${this.email}`;
    }
    message = encodeURIComponent(message);
    const roomSys = _.get(this, "current.census.roomSys", null);
    const browser = getBrowserString();
    const height = window.innerHeight.toFixed(0);
    const width = window.innerWidth.toFixed(0);
    const windowDim = {
      height,
      width
    };
    const parts = window.location.href.split("#");
    const route = parts.length > 1 ? parts[1] : parts[0];

    const postData = {
      windowDim: JSON.stringify(windowDim),
      message,
      roomSys,
      browser,
      route
    };

    this.accessRequest({
      data: postData,
      params: {
        action: "comment",
        area: this.area
      }
    }).then(
      () => {
        this.handleResponse(true);
      },
      () => {
        this.handleResponse(false);
      }
    );

    if (this.isActiveTest) {
      this.getLogIdAndCopy();
    }
  }

  private handleResponse(success: boolean) {
    this.error = "";
    if (success) {
      this.closeFeedback();
      this.sending = false;
      this.text = "";
    } else {
      this.sending = false;
      this.error = "Failed to send, please try again";
    }
  }

  async getLogIdAndCopy() {
    if (this.isActiveTest) {
      let tests = await this.getActiveCases();
      if (tests && Array.isArray(tests) && tests.length > 0) {
        const entry = tests[tests.length - 1]; // Get the last test in the list
        const logID = entry.logID;
        this.copyLogIdToClipboard(logID);
      }
    }
  }

  copyLogIdToClipboard(logID: string) {
    this.copyMessage(logID);
    alert('Copied "' + logID + '" to clipboard');
  }
  copyMessage(val: string) {
    const selBox = document.createElement("textarea");
    selBox.style.position = "fixed";
    selBox.style.left = "0";
    selBox.style.top = "0";
    selBox.style.opacity = "0";
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand("copy");
    document.body.removeChild(selBox);
  }
  closeFeedback() {
    this.dialogOpen = false;
  }

  cancel() {
    this.text = "";
    this.closeFeedback();
  }

  checkCommentField(value: string) {
    return (
      !!value ||
      "Required! Your comments or questions will help improve the AlertWatch program. The current case data will be recorded along with your message."
    );
  }
}
